/*
 This directive will capitalize a text input
 */
import {utilModule} from '../module.js';

utilModule.directive('capitalize', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, modelCtrl) {
            let capitalize = function(inputValue) {
                let capitalized = '';
                if (inputValue !== undefined) {
                    capitalized = inputValue.toUpperCase();
                    if (capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                }
                return capitalized;
            };
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]);
        }
    }
});
